import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Button, Typography, Menu, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useStyles } from '../styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { OMNI, ECOMMERCE, IN_STORE } from '../../../constants/constant';

function CustomTableFilter(props) {
    let { filter, parentCallback } = props;

	const classes = useStyles();
    
    const [metricSelect, setMetricSelect] = useState(false);
    const [filterValue, setFilterValue] = useState(filter);

    const handleSelect = (event) => {
        setMetricSelect(!metricSelect);
        setAnchorEl(event.currentTarget);
	};

    const [anchorEl, setAnchorEl] = React.useState(null);
 
    const handleClose = (event) => {
        setAnchorEl(null);
        setMetricSelect(!metricSelect);
        if(event != null && event.target != null 
            && event.target.id != 0 
            && event.target.id != null
            && event.target.id != undefined ){
            setFilterValue(event.target.id);
            filter = event.target.id;
        }

        parentCallback(filter);
        event.preventDefault();
    };


	return (
        <Box className={classes.table_toolbarBackground}>
            <Box>
                {metricSelect ? 
                <>
                    <Button 
                        className={classes.table_activeToolbarButton}
                        onClick={handleSelect}
                        aria-controls="simple-menu"
                        aria-haspopup="true">
                        <Box className={classes.table_toolbarButtonContainer}>
                            <Typography className={classes.table_toolbarButtonText}>
                                {filterValue}
                            </Typography>
                            {metricSelect ?
                                <ArrowDropUpIcon/>
                                : 
                                <ArrowDropDownIcon/>}
                        </Box>
                    </Button>
                    <Box className={classes.table_filterMenuContainer}>
                        <Menu
                            className={classes.table_filterMenu}
                            keepMounted
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            open={Boolean(anchorEl)}>
                            <MenuItem id={OMNI} onClick={handleClose} className={classes.table_filterOptions}>{OMNI}</MenuItem>
                            <MenuItem id={IN_STORE} onClick={handleClose} className={classes.table_filterOptions}>{IN_STORE}</MenuItem>
                            <MenuItem id={ECOMMERCE} onClick={handleClose} className={classes.table_filterOptions}>{ECOMMERCE}</MenuItem>
                        </Menu>
                    </Box>
                </>
                :
                <Button 
                    className={classes.table_toolbarButton}
                    onClick={handleSelect} 
                    value={filterValue}>
                    <Box className={classes.table_toolbarButtonContainer}>
                        <Typography className={classes.table_toolbarButtonText}>
                            {filterValue}
                        </Typography>
                        {metricSelect ?
                            <ArrowDropUpIcon/>
                            :
                            <ArrowDropDownIcon/>
                        }
                    </Box>
                </Button>
                }
                
            </Box>
        </Box>
	);
}

CustomTableFilter.propTypes = {
	filter: PropTypes.string.isRequired,
    parentCallback: PropTypes.func.isRequired
};

export default CustomTableFilter;
